<ion-content *ngIf="isLogging" class="bgwait"> </ion-content>
<ion-content *ngIf="!isLogging">
  <video
    *ngIf="isMobile"
    playsinline
    muted
    autoplay
    loop
    poster="assets/videos/portrait.jpg"
    #videoMobile>
    <source type="video/webm" src="/assets/videos/portrait.webm" />
    <source type="video/mp4" src="/assets/videos/portrait.mp4" />
  </video>
  <video
    *ngIf="!isMobile"
    playsinline
    muted
    autoplay
    loop
    poster="assets/videos/landscape.jpg"
    #videoDesktop>
    <source type="video/webm" src="assets/videos/landscape.webm" />
    <source type="video/mp4" src="assets/videos/landscape.mp4" />
  </video>
  <button
    class="ind-btn ind-btn--secondary"
    ion-button
    color="light"
    full
    [routerLink]="loginPath">
    LOGIN
  </button>
</ion-content>
